import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from './Layout';
import JobsDisplay from './JobsDisplay';

interface Project {
  _id: string;
  title: string;
  slug: string;
  description: string;
  imageUrl: string;
  category: string;
  network: string;
  tags: string[];
  featured: boolean;
}

const JobsPage: React.FC = () => {
  const [showServicesModal, setShowServicesModal] = useState(false);
  const [projects, setProjects] = useState<Project[]>([]);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await axios.get('/api/projects?status=active&isPublished=true');
      if (response.data.success) {
        setProjects(response.data.data.projects);
      }
    } catch (error) {
      console.error('Error fetching projects:', error);
    }
  };

  return (
    <Layout
      showServicesModal={showServicesModal}
      setShowServicesModal={setShowServicesModal}
      projects={projects}
      currentPage="other"
    >
      <JobsDisplay />
    </Layout>
  );
};

export default JobsPage;
